import type { BootstrapResponse, NormalizedRecord } from "./types";

/**
 * Fetch the bootstrap payload from the same-origin Python service.
 * Spec §4.2: legacy status_options (6) plus record_status_options (8).
 */
export async function fetchBootstrap(forceRefresh = false): Promise<BootstrapResponse> {
  const url = forceRefresh ? "/api/bootstrap?force_refresh=1" : "/api/bootstrap";
  const response = await fetch(url, { credentials: "same-origin" });
  if (!response.ok) {
    throw new Error(`bootstrap failed: ${response.status}`);
  }
  return response.json() as Promise<BootstrapResponse>;
}

export interface CreateRecordInput {
  content: string;
  theme?: string;
  category?: string;
  priority?: string;
  status?: string;
}

export async function createRecord(input: CreateRecordInput): Promise<NormalizedRecord> {
  const response = await fetch("/api/console/records", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!response.ok) {
    throw new Error(`create record failed: ${response.status}`);
  }
  return response.json() as Promise<NormalizedRecord>;
}

export interface UpdateRecordInput {
  content?: string;
  theme?: string;
  category?: string;
  priority?: string;
  status?: string;
}

export async function updateRecord(
  recordId: string,
  input: UpdateRecordInput,
): Promise<NormalizedRecord> {
  const response = await fetch(`/api/records/${encodeURIComponent(recordId)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!response.ok) {
    throw new Error(`update record failed: ${response.status}`);
  }
  return response.json() as Promise<NormalizedRecord>;
}
